export function isFeatureFlagEnabled(state, featureFlag) {
	return state.getIn(["featureFlags", featureFlag], true) === true;
}
